// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3rSP3","productName":"Table_productName__34fsa"};